export interface State {
  entity: any;
}

export const INITIAL_STATE: State = {
  entity: null
};
